import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { ModalController, NavParams } from '@ionic/angular';
import { Item } from 'src/app/models/item';

@Component({
  selector: 'app-item-create',
  template: `
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ 'ITEM_CREATE_TITLE' | translate }}</ion-title>
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">
            <span color="primary" showWhen="ios">
              {{ 'CANCEL_BUTTON' | translate }}
            </span>
            <ion-icon name="md-close" showWhen="android,windows"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button (click)="done()" [disabled]="!isReadyToSave" strong>
            <span color="primary" showWhen="ios">
              {{ 'DONE_BUTTON' | translate }}
            </span>
            <ion-icon name="md-checkmark" showWhen="core,android,windows"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <form *ngIf="form" [formGroup]="form" (ngSubmit)="createItem()">
        <input type="file" #fileInput style="visibility: hidden; height: 0px" name="files[]" (change)="processWebImage($event)" />
        <div class="profile-image-wrapper" (click)="getPicture()">
          <div class="profile-image-placeholder" *ngIf="!this.form.controls.profilePic.value">
            <ion-icon name="add"></ion-icon>
            <div>
              {{ 'ITEM_CREATE_CHOOSE_IMAGE' | translate }}
            </div>
          </div>
          <div class="profile-image" [style.backgroundImage]="getProfileImageStyle()" *ngIf="this.form.controls.profilePic.value"></div>
        </div>
        <ion-list>
          <ion-item>
            <ion-input type="text" placeholder="{{ 'ITEM_NAME_PLACEHOLDER' | translate }}" formControlName="name"></ion-input>
          </ion-item>
          <ion-item>
            <ion-input type="text" placeholder="{{ 'ITEM_ABOUT_PLACEHOLDER' | translate }}" formControlName="about"></ion-input>
          </ion-item>
        </ion-list>
      </form>
    </ion-content>
  `,
  styleUrls: ['./item-create.page.scss']
})
export class ItemCreatePage implements OnInit {
  @ViewChild('fileInput') fileInput;

  isReadyToSave: boolean;

  item: any;

  form: FormGroup;

  constructor(private modalController: ModalController, formBuilder: FormBuilder, public camera: Camera) {
    this.form = formBuilder.group({
      profilePic: [''],
      name: ['', Validators.required],
      about: ['']
    });

    // Watch the form for changes, and
    this.form.valueChanges.subscribe(v => {
      this.isReadyToSave = this.form.valid;
    });
  }

  ngOnInit() {}
  createItem() {}
  getPicture() {
    if (Camera['installed']()) {
      this.camera
        .getPicture({
          destinationType: this.camera.DestinationType.DATA_URL,
          targetWidth: 96,
          targetHeight: 96
        })
        .then(
          data => {
            this.form.patchValue({ profilePic: 'data:image/jpg;base64,' + data });
          },
          err => {
            alert('Unable to take photo');
          }
        );
    } else {
      this.fileInput.nativeElement.click();
    }
  }

  processWebImage(event) {
    let reader = new FileReader();
    reader.onload = readerEvent => {
      let imageData = (readerEvent.target as any).result;
      this.form.patchValue({ profilePic: imageData });
    };

    reader.readAsDataURL(event.target.files[0]);
  }

  getProfileImageStyle() {
    return 'url(' + this.form.controls['profilePic'].value + ')';
  }

  /**
   * The user cancelled, so we dismiss without sending data back.
   */
  cancel() {
    this.modalController.dismiss();
  }

  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    if (!this.form.valid) {
      return;
    }
    this.modalController.dismiss(this.form.value);
  }
}
